export default class LinkedInQuery {

    public static GetAccessToken = `query GetAccessTokenQuery($input: LinkedInAccessTokenInput!) {
            getLinkedInAccessToken(input: $input) {
                code
            }     
        }`;
}